module.exports = __webpack_public_path__ + "static/media/somewheregood.a5c95430.png";